<template>
  <div class="wrapper">
    <div class="searchconditions">
      <el-form :model="listForm" ref="listForm" inline>
        <el-form-item prop="companyName" label="经销商信息">
          <el-input
            v-model="listForm.companyName"
            placeholder="请输入经销商名称或编码"
            maxlength="50"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button icon="el-icon-search" type="cyan" @click="searchList"
            >查询</el-button
          >
          <el-button icon="el-icon-refresh" type="warning" @click="reset"
            >重置</el-button
          >
        </el-form-item>
      </el-form>
    </div>
    <el-row :gutter="10" class="button-box">
      <!-- <el-col :span="1.5">
        <el-button
          icon="el-icon-plus"
          size="mini"
          type="primary"
          @click="addAgent"
          >新增</el-button
        >
      </el-col> -->
    </el-row>
    <el-table :data="list" v-loading="loading" border style="width: 100%">
      <el-table-column
        type="index"
        label="序号"
        width="80"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="companyName"
        label="经销商名称"
        min-width="150"
        align="center"
      >
      </el-table-column>
      <el-table-column
        prop="companyCode"
        label="经销商编号"
        min-width="120"
        align="center"
      >
      </el-table-column>
      <el-table-column
        prop="companyInfoExtendList"
        label="代理区域"
        min-width="120"
        align="center"
      >
        <template slot-scope="scope">
          <div
            v-for="(item, index) in scope.row.companyInfoExtendList"
            :key="index"
          >
            <span v-if="item.provCode">{{ item.provCode | getprov }}</span>
            <span v-if="item.cityCode"> - {{ item.cityCode | getprov }} </span>
            <span v-if="item.areaCode"> - {{ item.areaCode | getprov }} </span>
          </div>
        </template>
      </el-table-column>
      <!-- <el-table-column
        prop="agentCompanyName"
        align="center"
        label="经销商类型"
        min-width="150"
      >
        <template slot-scope="scope">
          <span v-if="scope.row.registType == 1">经销商</span>
          <span v-if="scope.row.registType == 2">终端门店</span>
        </template> </el-table-column
      ><el-table-column
        prop="agentLevel"
        label="经销级别"
        align="center"
        min-width="120"
      >
        <template slot-scope="scope">
          <span v-if="scope.row.agentLevel == 1">省级经销商</span>
          <span v-if="scope.row.agentLevel == 2">市级经销商</span>
          <span v-if="scope.row.agentLevel == 3">县级经销商</span>
        </template>
      </el-table-column> -->
      <el-table-column
        label="操作"
        align="center"
        min-width="150"
        fixed="right"
      >
        <template slot-scope="scope">
          <el-button
            type="primary"
            size="mini"
            icon="el-icon-view"
            @click="handleEdit(scope.row, 1)"
          >
            详情
          </el-button>
          <el-button
            type="primary"
            size="mini"
            icon="el-icon-edit"
            @click="handleEdit(scope.row, 2)"
          >
            编辑
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      background
      layout="prev, pager, next, sizes, total, jumper"
      :page-sizes="[10, 15, 20]"
      :page-size="listForm.pageSize"
      :total="total"
      :current-page="listForm.pageNum"
      @current-change="handlePageChange"
      @size-change="handleSizeChange"
    >
    </el-pagination>
    <el-dialog
      :title="title"
      :visible.sync="dialogEdit"
      :close-on-click-modal="false"
      class="company_detail"
      width="800px"
      @close="dialogEditClose"
    >
      <el-form
        :model="editForm"
        :rules="rules"
        ref="editForm"
        label-width="125px"
      >
        <el-row>
          <el-col :span="16">
            <el-form-item label="经销商编码：" prop="companyCode">
              <el-input
                v-model="editForm.companyCode"
                placeholder="请输入经销商名称"
                :disabled="isDetail"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="16">
            <el-form-item label="经销商名称：" prop="companyName">
              <el-input
                v-model="editForm.companyName"
                placeholder="请输入经销商名称"
                :disabled="isDetail"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="16">
            <el-form-item label="经销商类型：" prop="contactPerson">
              <el-input
                v-model="editForm.contactPerson"
                placeholder="请输入经销商类型"
                :disabled="isDetail"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="16">
            <el-form-item label="经销商级别：" prop="contactPhone">
              <el-input
                v-model="editForm.contactPhone"
                placeholder="请输入经销商级别"
                :disabled="isDetail"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="16">
            <el-form-item
              label="所在区域："
              prop="companyAddress"
            >
              <!-- :rules="[
                {
                  required: true,
                  validator: (rule, value, callback) => {
                    testCompanyAddress(rule, value, callback);
                  },
                  trigger: 'change'
                }
              ]" -->
              <el-cascader
                ref="province"
                :options="cityList"
                :props="{ checkStrictly: true }"
                v-model="companyAddress"
                expand-trigger="click"
                filterable
                style="width: 100% !important"
                :disabled="isDetail"
              >
              </el-cascader>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="16">
            <el-form-item label="详细地址：" prop="address">
              <el-input
                v-model="editForm.address"
                placeholder="请输入详细地址"
                :disabled="isDetail"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="16">
            <el-form-item
              label="代理区域："
            >
              <!-- :rules="[
                {
                  required: true,
                  validator: (rule, value, callback) => {
                    testDealerAddress(rule, value, callback);
                  },
                  trigger: 'change'
                }
              ]" -->
              <el-cascader
                ref="dealerAddress"
                style="width:100%"
                v-model="dealerAddress"
                :options="cityList"
                :props="{ multiple: true, checkStrictly: true }"
                :disabled="isDetail"
              ></el-cascader>
              <!-- <el-cascader
                ref="province"
                style="width:100%"
                v-model="dealerAddress"
                :options="cityList"
                :props="{ multiple: true, checkStrictly: true }"
                v-else
              ></el-cascader> -->
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer">
        <el-button @click="dialogEdit = false">取消</el-button>
        <el-button type="primary" @click="saveDataEdit" v-show="!isDetail"
          >确 定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { comanyPageList, saveOrUpdateDealer } from "@/common/api.js";
import cityList from "@/common/province.json";
import util from "@/common/util.js";
export default {
  components: {},
  props: {},
  data() {
    return {
      //列表
      total: 0,
      loading: false,
      listForm: {
        pageNum: 1,
        pageSize: 10,
        companyType: 8,
        companyName: ""
      },
      loginCompanyType: "", //1 泸天化  2 九禾
      list: [],
      isDetail: false,
      cityList: cityList,
      dialogEdit: false,
      title: "编辑经销商",
      companyAddress: [],
      dealerAddress: [],
      editForm: {
        companyId: "",
        companyCode: "",
        companyName: "",
        contactPerson: "",
        contactPhone: "",
        provCode: "",
        cityCode: "",
        areaCode: "",
        address: "",
        companyType: 8,
        joinTime: "",
        companyInfoExtendList: []
      },
      rules: {
        // companyCode: [
        //   { required: true, message: "未获取经销商编号", trigger: "blur" }
        // ],
        companyName: [
          { required: true, message: "请输入经销商名称", trigger: "blur" }
        ]
        // contactPerson: [
        //   { required: true, validator: this.testPerson, trigger: "blur" }
        // ],
        // contactPhone: [
        //   { required: true, validator: this.testPhone, trigger: "change" }
        // ],
        // address: [
        //   { required: true, message: "请输入详细地址", trigger: "blur" }
        // ],
        // joinTime: [
        //   { required: true, message: "请选择加盟时间", trigger: "change" }
        // ]
      }
    };
  },
  watch: {},
  computed: {},
  methods: {
    getPageList() {
      let params = this.listForm;
      this.loading = true;
      comanyPageList(params).then(res => {
        if (res.errorCode == 200) {
          this.list = res.data.list;
          this.total = res.data.total;
        } else {
          this.$message({
            message: res.msg,
            type: "error"
          });
        }
        this.loading = false;
      });
    },
    // 查询
    searchList() {
      this.listForm.pageNum = 1;
      this.getPageList();
    },
    // 新增
    addAgent() {
      this.dialogEdit = true;
    },
    // 搜索框重置
    reset() {
      this.$nextTick(() => {
        this.$refs["listForm"].resetFields();
        this.listForm = {
          pageNum: 1,
          pageSize: 10,
          companyType: 8,
          companyName: ""
        };
        this.getPageList();
      });
    },
    // 分页
    handlePageChange(cpage) {
      this.listForm.pageNum = cpage;
      this.getPageList();
    },
    handleSizeChange(psize) {
      this.listForm.pageSize = psize;
      this.getPageList();
    },
    handleEdit(row, type) {
      this.dialogEdit = true;
      if (type == 1) {
        this.isDetail = true;
        this.title = "查看";
      } else {
        this.isDetail = false;
        this.title = "编辑";
      }
      this.$nextTick(() => {
        this.editForm = {
          companyId: row.companyId,
          companyCode: row.companyCode,
          companyName: row.companyName,
          contactPerson: row.contactPerson,
          contactPhone: row.contactPhone,
          registType: row.registType,
          agentLevel: row.agentLevel,
          provCode: row.provCode,
          cityCode: row.cityCode,
          areaCode: row.areaCode,
          address: row.address,
          // joinTime: row.joinTime,
          // companyType: 8,
          companyInfoExtendList: row.companyInfoExtendList
        };
        if (row.areaCode) {
          this.companyAddress = [row.provCode, row.cityCode, row.areaCode];
        } else if (row.cityCode && !row.areaCode) {
          this.companyAddress = [row.provCode, row.cityCode];
        } else if (row.provCode && !row.cityCode && !row.areaCode) {
          this.companyAddress = [row.provCode];
        }
        console.log(this.companyAddress);
        let arr = [];
        if (row.companyInfoExtendList && row.companyInfoExtendList.length) {
          row.companyInfoExtendList.forEach(item => {
            if (item.areaCode) {
              arr.push([item.provCode, item.cityCode, item.areaCode]);
            } else if (item.cityCode && !item.areaCode) {
              arr.push([item.provCode, item.cityCode]);
            } else if (item.provCode && !item.cityCode && !item.areaCode) {
              arr.push([item.provCode]);
            }
          });
          this.dealerAddress = arr;
        } else {
          this.dealerAddress = [];
        }
        console.log(this.dealerAddress);
      });
    },
    testCompanyAddress(rule, value, callback) {
      console.log(this.companyAddress.length);
      if (this.companyAddress.length == 0) {
        callback(new Error("请选择企业地址"));
      }
      callback();
    },
    testDealerAddress(rule, value, callback) {
      if (this.dealerAddress.length == 0) {
        callback(new Error("请选择代理区域"));
      }
      callback();
    },
    // 编辑保存、
    saveDataEdit() {
      this.$refs["editForm"].validate(valid => {
        // console.log(valid);
        // return;
        if (valid) {
          if (this.companyAddress.length) {
            this.editForm.provCode = this.companyAddress[0];
            this.editForm.cityCode = this.companyAddress[1] || "";
            this.editForm.areaCode = this.companyAddress[2] || "";
          }
          if (this.dealerAddress.length) {
            let arr = [];
            this.dealerAddress.forEach(item => {
              arr.push({
                provCode: item[0],
                cityCode: item[1],
                areaCode: item[2]
              });
            });
            this.editForm.companyInfoExtendList = arr;
          } else {
            this.editForm.companyInfoExtendList = [];
          }
          var params = this.editForm;
          saveOrUpdateDealer(params).then(res => {
            if (res.errorCode == 200) {
              this.dialogEdit = false;
              this.getPageList();
            } else {
              this.$message.error(res.msg);
            }
          });
        }
      });
    },
    dialogEditClose() {
      // this.$refs.dealerAddress.$refs.panel.checkedValue = [];
      this.$refs.dealerAddress.$refs.panel.activePath = [];
      // this.$refs.dealerAddress.$refs.panel.syncActivePath();
      this.$nextTick(() => {
        this.editForm = {
          id: "",
          companyId: "",
          companyCode: "",
          companyName: "",
          contactPerson: "",
          contactPhone: "",
          provCode: "",
          cityCode: "",
          areaCode: "",
          address: "",
          companyInfoExtendList: [],
          companyType: 8
        };
        this.companyAddress = [];
        this.dealerAddress = [];
        this.isDetail = false;
        this.$refs["editForm"].resetFields();
      });
    }
  },
  created() {},
  mounted() {
    this.loginCompanyType = window.sessionStorage.getItem("loginCompanyType");
    this.getPageList();
  },
  filters: {
    getprov(code) {
      cityList.forEach((item, index) => {
        if (code == item.value) {
          code = item.label;
        } else if (item.children.length > 0) {
          item.children.forEach(c => {
            if (code == c.value) {
              code = c.label;
            } else {
              if (c.children.length > 0) {
                c.children.forEach(cc => {
                  if (code == cc.value) {
                    code = cc.label;
                  }
                });
              }
            }
          });
        }
      });
      return code;
    }
  }
};
</script>
<style lang="less" scoped>
.wrapper {
  .searchconditions {
    width: calc(100% - 30px);
    background: #fff;
    border-radius: 6px;
    padding: 20px 15px;
    box-shadow: 1px 1px 3px rgba(0, 0, 0, 0.2);
    .el-form {
      .el-form-item {
        display: inline-block;
        margin-right: 10px;
        vertical-align: top;
        margin: 5px 15px 5px 0px;
        /deep/.el-button {
          padding: 8px 15px;
          font-size: 12px;
          border-radius: 3px;
        }
      }
    }
  }

  .el-row {
    margin: 10px 0 0 !important ;
    border-top-left-radius: 6px;
    border-top-right-radius: 6px;
    background-color: #ffffff;
    padding: 5px 15px 0;
    .add-btn {
      float: left;
      padding: 0;
      margin-top: 5px;
      margin-bottom: 10px;
      .el-button {
        padding: 8px 15px;
        font-size: 12px;
        border-radius: 3px;
      }
    }
    .btn-group-right {
      float: right;
      .el-button {
        padding: 8px;
      }
    }
    .btn-group-right {
      margin-top: 5px;
      span {
        display: inline-block;
        vertical-align: top;
        font-size: 20px;
        padding: 8px;
      }
    }
  }
}
.sync-box {
  float: right;
  margin-right: 20px;
  color: #f56c6c;
  font-size: 14px;
  text-align: right;
}
.sync-box1 {
  color: #333333;
}
.button-box {
  padding: 15px !important ;
}
.address /deep/.el-form-item__content {
  margin-left: 0 !important;
}
.custom-data .el-table__header-wrapper .el-checkbox {
  display: none;
}
.company_detail /deep/ .el-dialog__body {
  padding: 10px 15px 30px;
}
.toolbar {
  .searchName .el-input {
    width: 180px !important;
  }
  .searchLevel /deep/ .el-input {
    width: 140px !important;
  }
}
.detail_li {
  height: 40px;
  line-height: 40px;
  width: 100%;
  .span {
    font-size: 14px;
    color: #606266;
  }
  .detail_num {
    float: left;
    width: 100px;
    text-align: right;
  }
  .detail__num_val {
    padding-left: 30px;
  }
}
.detail_li_s {
  min-height: 40px;
  width: 100%;
  .detail_area {
    height: 40px;
    width: 100px;
    line-height: 40px;
    text-align: right;
    vertical-align: top;
    display: inline-block;
  }
  .detail_area_box {
    width: calc(100% - 100px);
    display: inline-block;
    vertical-align: top;
  }
}
.detail_name {
  float: left;
  width: 50%;
}
.deltail_company {
  float: left;
  height: 40px;
  line-height: 40px;
  width: 100px;
  font-size: 14px;
  color: #606266;
  text-align: right;
}
.deltail_company_name {
  float: left;
  height: 40px;
  line-height: 40px;
  width: 100px;
  font-size: 14px;
  color: #606266;
  text-align: left;
  padding-left: 30px;
}
.deltail_company_area {
  float: left;
  height: 40px;
  line-height: 40px;
  font-size: 14px;
  color: #606266;
  text-align: left;
  padding-left: 30px;
}
.remark {
  overflow: hidden;
  float: left;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: calc(100% - 150px);
}
.company_eval {
  padding-left: 30px;
  float: left;
  line-height: 40px;
}
.avatar-uploader {
  /deep/.el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .el-upload:hover {
    border-color: #409eff;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 100px;
    height: 100px;
    line-height: 100px;
    text-align: center;
  }
  .avatar {
    width: 100px;
    height: 100px;
    display: block;
  }
}
.wrapper {
  .title {
    text-align: left;
    margin-bottom: 20px;
    .text {
      color: red;
    }
    .img {
      margin-top: 80px;
    }
  }
  .companyNum {
    width: 45%;
  }
  // .city-list {
  // display: inline-block;
  // }
  .addArea {
    vertical-align: top;
    font-size: 30px;
    line-height: 40px;
    margin-left: 10px;
  }
  .statusBtn {
    display: inline-block;
    height: 40px;
    width: 60px;
    text-align: center;
    margin-right: 20px;
    border: 1px solid #8b8787;
  }
  .status1 {
    background-color: green;
    color: #ffffff;
  }
  .el-rate {
    height: 40px;
    line-height: 40px;
  }
  .el-rate__item {
    vertical-align: null !important;
  }
  .address /deep/.el-form-item__content {
    margin-left: 10px !important;
  }
  // /deep/.el-table .cell{
  //   white-space: nowrap;
  // }
  .info {
    width: 50%;
    height: 400px;
    margin: 50px auto 0;
    background-color: #fff;
    padding: 50px;
    .l1 {
      border-bottom: 1px solid #eee;
      .span1 {
        font-size: 20px;
        margin-right: 40px;
      }
      .span2 {
        font-size: 16px;
        color: #428bca;
      }
    }
    .l2 {
      margin-top: 40px;
      .d1 {
        font-size: 20px;
        margin-right: 40px;
        border-bottom: 1px solid #eee;
      }
      .d2 {
        margin-top: 40px;
        div {
          margin-bottom: 20px;
        }
        .span3 {
          display: inline-block;
          width: 150px;
          font-size: 18px;
          color: #8a8a8a;
          margin-right: 100px;
        }
        .span4 {
          font-size: 16px;
          color: #428bca;
        }
      }
    }
  }
  .el-form-item {
    margin-bottom: 10px;
  }
  .onlineCompany {
    /deep/.el-form-item__label {
      margin-right: 20px;
    }
  }
  .custom-table /deep/th .el-checkbox__inner {
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/system/businessManage/dealerManage.vue